import { useState } from "react";
import { downloadBlob, exportUrl } from "@/lib/api";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Video, Loader2, ChevronDown, Monitor, Smartphone } from "lucide-react";
import { toast } from "sonner";

const OPTIONS = [
  { shape: "wide", subtitles: "soft", icon: Monitor, label: "Widescreen", hint: "Subtitles you can switch on/off", suffix: "" },
  { shape: "wide", subtitles: "burned", icon: Monitor, label: "Widescreen + subtitles on video", hint: "Best for YouTube & WhatsApp", suffix: " (subtitled)" },
  { shape: "vertical", subtitles: "burned", icon: Smartphone, label: "Vertical 9:16 + subtitles on video", hint: "Instagram Reels & WhatsApp Status", suffix: " (vertical, subtitled)" },
  { shape: "vertical", subtitles: "soft", icon: Smartphone, label: "Vertical 9:16", hint: "Subtitles you can switch on/off", suffix: " (vertical)" },
];

export const VideoDownloadMenu = ({ projectId, name, disabled }) => {
  const [busy, setBusy] = useState(null);

  const go = async (o) => {
    const key = `${o.shape}-${o.subtitles}`;
    setBusy(key);
    try {
      await downloadBlob(`${exportUrl(projectId, "movie-video")}?shape=${o.shape}&subtitles=${o.subtitles}`, `${name}${o.suffix}.mp4`);
      toast.success("Video downloaded");
    } catch {
      toast.error("Video download failed, please try again");
    }
    setBusy(null);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled || !!busy}>
        <button data-testid="download-movie-video-btn" className="inline-flex items-center gap-2 rounded-full text-sm px-4 py-2 bg-[#22C55E] text-[#0F1117] font-semibold hover:opacity-90 transition-opacity disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Video className="h-4 w-4" />}
          {busy ? "Building video…" : "Download video"} <ChevronDown className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="bg-[#1E293B] border-white/10 w-80">
        <DropdownMenuLabel className="text-xs text-[#94A3B8]">Narrated MP4 with voiceover</DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-white/10" />
        {OPTIONS.map((o) => (
          <DropdownMenuItem key={`${o.shape}-${o.subtitles}`} data-testid={`video-option-${o.shape}-${o.subtitles}`} onSelect={() => go(o)} className="cursor-pointer gap-3 py-2">
            <o.icon className="h-4 w-4 text-[#22C55E] shrink-0" />
            <div>
              <div className="text-sm text-[#F8FAFC]">{o.label}</div>
              <div className="text-xs text-[#94A3B8]">{o.hint}</div>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
